import '@/app/app.css';
import './main.css';
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';

import '@/app/app';

import { productsSlider } from '@/features/products-slider/products-slider';
import { mainCategoriesSlider } from '@/features/main/main-categories/main-categories';
import { brandsSlider } from '@/features/brands-slider/brands-slider';
import { mainReviewsSlider } from '@/features/main/main-reviews/main-reviews';

window.addEventListener('DOMContentLoaded', () => {
	productsSlider();
	mainCategoriesSlider();
	brandsSlider();
	mainReviewsSlider();
});
